import React, {useRef} from 'react';
import {connect} from "react-redux";
import {updateDataStore} from "src/actions/foundationActions";
import {submitFeatureFeedback} from "src/containers/TDP/TDPWebsiteFunctions";
import {ratingIcons} from "src/datamodels/foundation";
import gsap from 'gsap';

const FeatureApprovalRating = (props) => {
    const tooltipRef = useRef();
    const tooltipInnerRef = useRef();

    let clickFunc = props.clickFunc ? props.clickFunc : submitFeatureFeedback;

    function showTip(){
        gsap.set(tooltipRef.current,{display:"flex"});
    }

    function hideTip(){
        gsap.set(tooltipRef.current,{display:"none"});
    }

    return (
        <div style={{display:"inline",position:"relative"}} onMouseOver={()=>showTip()} onMouseOut={()=>hideTip()}>
            <span
                className="featureApprovalRating mr-2"
                style={{fontSize:"x-large",cursor:"pointer"}}
                onClick={()=>clickFunc(props.vote,props.feature,props.audience)}>
                    {ratingIcons[props.vote]}
            </span>
            <div className="tootip-tn" ref={tooltipRef}><span className="tootip-tn-inner" ref={tooltipInnerRef}>{props.title}</span></div>
        </div>
    )
};

const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        dataStore:state.dataStore,
        user:state.user
    };
};

export default connect(mapStateToProps,{
    updateDataStore
})(FeatureApprovalRating);
